
//Agar mudah menilai ikuti langkah langkah berikut :
//Tekan Ctrl + F
//lalu ketik keyword "(SUDAH)"

// No. 1 (SUDAH) Buat FIle baru Bernama GhostBusterScene.js pada folde scene 

import Phaser from 'phaser'
// @ts-ignore
import Bomb from '../ui/Bomb'
// @ts-ignore
import Ghost from '../ui/Ghost'
// @ts-ignore

import ScoreLabel from '../ui/ScoreLabel'

export default class GhostBusterScene extends Phaser.Scene
//No. 2 (SUDAH) Buat Struktur kelas GHostBusterScene 
{
	constructor()
	{
		super('ghost_buster_scene')
	}

    init() {
        this.ground = undefined
        this.player = undefined
        this.bombs = undefined
        this.enemies = undefined
        this.enemySpeed = 60
        this.cursor = undefined
        this.button = undefined
        this.lastFired = 0
        this.speed = 100
        this.scoreLabel = undefined
        this.backsound = undefined
    }

	preload()
    {
        //No. 3 (SUDAH) Buat kode Load semua Image dan Sprite Sheet 
        this.load.image('background', 'images/background.png')
        this.load.image('background2', 'images/background2.png')
        this.load.image('bird', 'images/birds.png')
        this.load.image('bomb', 'images/bomb.png')
        this.load.image('enemy', 'images/ghost.png')
        this.load.image('ground', 'images/ground.png')
        this.load.image('spooky_tree', 'images/spookyTree.png')
        this.load.image('fog', 'images/fog.png')
        this.load.image('spooky_house', 'images/spookyHouse.png')
        this.load.spritesheet('player', 'images/player.png', {frameWidth : 32, frameHeight : 32})

        this.load.audio('backsound', 'sfx/backsound/haggstrom.mp3')
        this.load.audio('gameOverSound', 'sfx/gameover.wav')
    }

    create()
    {
        //No. 4 (SUDAH) Buat kode create semua image dan Sprite Sheet 
        this.cursor = this.input.keyboard.createCursorKeys()

        this.add.image(256, 250, 'background')
        this.add.image(256, 250, 'background2').setScale(0.7)
        this.add.image(400, 350, 'spooky_tree').setFlipX(true).setScale(0.5)
        this.add.image(256, 250, 'fog').setDepth(2).setScale(0.8)
        this.add.image(256, 495,'ground').setScale(2)
        this.add.image(100, 360, 'spooky_house').setScale(0.27)
        this.add.image(150, 100, 'bird').setScale(0.3)


        this.ground = this.physics.add.staticGroup()
        this.ground.create(256, 495,'ground').setScale(2).refreshBody()


        this.player = this.physics.add.sprite(256, 450, 'player')
        this.player.setCollideWorldBounds(true)

        this.player = this.createPlayer()

        //No. 5 (SUDAH) Buat kode agar player berdiri di atas ground 
        this.physics.add.collider(this.player, this.ground)

        this.button = this.input.keyboard.addKeys({
            shoot : Phaser.Input.Keyboard.KeyCodes.SPACE,
            up : Phaser.Input.Keyboard.KeyCodes.W,
            down : Phaser.Input.Keyboard.KeyCodes.S,
            left : Phaser.Input.Keyboard.KeyCodes.A,
            right : Phaser.Input.Keyboard.KeyCodes.D
        })  

        this.enemies = this.physics.add.group({
            classType : Ghost,
            maxSize : 10,
            runChildUpdate : true
        })

        this.time.addEvent({
            delay: 1000,
            callback: this.spawnEnemy,
            callbackScope: this,
            loop: true
            })
        
        this.bombs = this.physics.add.group({
            classType : Bomb,
            maxSize : 10,
            runChildUpdate : true
        })

        this.physics.add.overlap(
            
            this.bombs, 
            this.enemies, 
            this.hitEnemy, 
            null, 
            this
        );
        this.scoreLabel = this.createScoreLabel(340, 10, 0)

        //Bonus Point No.2 (SUDAH)(Baris = 292)
        this.physics.add.overlap(
            this.enemies,
            this.player,
            this.gameOverScene,
            null,
            this
        )

        this.backsound = this.sound.add('backsound')
        var soundConfig = {
            loop : true,
            volume : 0.1
        }
        this.backsound.play(soundConfig)

    }

    update(time) {

        
        this.movePlayer(this.player, time)
        
    }

    //No. 6 (SUDAH) Buat kode untuk menggerakan player menggunakan Key Arrows 

    movePlayer(player, time){
        // @ts-ignore
        // No. 7 (SUDAH) Buat kode untuk menembakkan bomb jika tombol spasi di tekan 
        if((this.button.shoot.isDown) && time > this.lastFired){
            const bomb = this.bombs.get(0, 0, 'bomb')
            
            if(bomb){
                bomb.fire(this.player.x, this.player.y)
                this.lastFired = time + 350
            }
        // @ts-ignore
        }else if(this.button.shoot.isDown) {
            this.player.anims.play('shooting', true)
        }else
         // @ts-ignore
        if (this.cursor.left.isDown || this.button.left.isDown){
            this.player.setVelocityX(this.speed * -1.3)

            this.player.anims.play('left', true)

            this.player.setFlipX(false)

            this.player.setFlipY(false)
        }
        // @ts-ignore
        else if (this.cursor.right.isDown || this.button.right.isDown){
            //kanan
            this.player.setVelocityX(this.speed * 1.3)

            this.player.anims.play('right', true)

            this.player.setFlipY(false)
        }
        // @ts-ignore
        else if (this.cursor.up.isDown || this.button.up.isDown) {//atas //kecepatanke atas lompat
            this.player.setVelocityY(this.speed * -1.5)

            this.player.anims.play('up', true)
        }

        // @ts-ignore
        else if (this.cursor.down.isDown || this.button.down.isDown) {//atas //kecepatanke atas lompat
            this.player.setVelocityY(this.speed * 0.8)

            this.player.anims.play('down', true)

            this.player.setFlipY(true)
        }
        else {this.player.setVelocityX(0)

            this.player.anims.play('turn')

            this.player.setFlipY(false)
        }
    }


    //Bonus Point No.1 (SUDAH) Buat animasi player saat bergerak ke kanan, ke kiri, dan stand by 
    createPlayer(){

        this.anims.create({
            key : 'turn',
            frames: [{key: 'player', frame:1}],
        })

        this.anims.create({
            key: 'left',
            frames:this.anims.generateFrameNumbers(
                'player', {start:3, end:5}),
            frameRate:10
        })

        this.anims.create({
            key : 'right',
            frames: this.anims.generateFrameNumbers(
                'player', {start:8, end:6}),
            frameRate: 10
        })

        this.anims.create({
            key : 'up',
            frames: this.anims.generateFrameNumbers(
                'player', {start:9, end:11}),
            frameRate : 5
        })

        this.anims.create({
            key:'down',
            frames: this.anims.generateFrameNumbers(
                'player', {start:9, end:11}),
            frameRate: 5
        })

        this.anims.create({
            key:'shooting',
            frames: this.anims.generateFrameNumbers(
                'player', {start: 10, end: 10}),
                frameRate: 10
        })

        return this.player
    }

    //No.8 (SUDAH) Buat kode untuk SPawn Ghost 
    spawnEnemy(){
        const config = {
            speed : this.enemySpeed,
            rotation : 0
            }
        // @ts-ignore
        const enemy = this.enemies.get(0,0,'enemy',config)

        const enemyWidth = enemy.displayWidth

        const positionX = Phaser.Math.Between(enemyWidth,
        this.scale.width - enemyWidth)

        if (enemy) {
            enemy.spawn(positionX)
        }
    }      

    //No. 9 (SUDAH) Buat Kode untuk Hit Ghost 
    hitEnemy(bomb, enemy){
        bomb.erase()
        enemy.die()

        this.scoreLabel.add(1)
        if(this.scoreLabel.getScore() % 100 == 0){
            this.enemySpeed += 30
        }
    }

    //No. 10 (SUDAH) tambahkan teks Score. jika bomb overlaps Ghost, score bertambah 1
    createScoreLabel(x,y,Score){
        const style = {fontSize: '32px', fill: '#FF0000'}
        const label = new ScoreLabel(this, x, y, Score, style).setDepth(1)

        this.add.existing(label)

        return label
    }



    //Bonus Point No.2 (SUDAH) Buat game over scene. Jika player Menyentuh GHost, maka game over (Baris = 120)
    gameOverScene(){
        this.scene.start('game-over-scene')
        this.sound.stopAll()
        this.sound.play('gameOverSound')
    }
}
